import { gql } from "@apollo/client";

export const GET_PARTNER_FORMS = gql`
  query GetPartnerDetailsForm($nif: String!) {
    getPartnerDetailsForm(nif: $nif) {
      address
      asfNumber
      asfPdf {
        name
        url
      }
      consents {
        usageConsent
        accuracyConsent
        dataConsent
      }
      additionalAttributes {
        isSameCommercial
        isSameFinancial
      }
      authorized
      cae
      citizenCardPdf {
        name
        url
      }
      legalRepresentativePdf {
        name
        url
      }
      city
      adminContact {
        personEmail
        personName
        personPhone
        userId
      }
      commercialContact {
        personEmail
        personName
        personPhone
        userId
      }
      financialContact {
        userId
        personName
        personEmail
        personPhone
      }
      legalContact {
        personEmail
        personName
        personLegalId
        personBirthdate
        personPhone
        userId
      }
      insurancePolicyNumber
      insurancePolicyRenewalDate
      name
      nif
      particularConditionsPdf {
        name
        url
      }
      pdeamsPdf {
        name
        url
        fileUuid
      }
      permanentCertificateNumber
      postalCode
      partnershipType
      verified
      uuid
    }
  }
`;

// Auth required
export const GET_PARTNER_STATUS = gql`
  query GetPartnerDetailsForm($nif: String!) {
    getPartnerDetailsForm(nif: $nif) {
      verified
    }
  }
`;

// No auth required
export const GET_PARTNER_STATUS_NEW = gql`
  query GetPartnerVerifiedStatus($nif: String, $proId: String) {
    getPartnerVerifiedStatus(nif: $nif, proId: $proId)
  }
`;
